import './polyfill';
import './public-path';

import { loadableReady } from '@loadable/component';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';

import { createBrowserHistory } from 'history';

import { ApiClientProvider } from '@travel/api-client';
import { setReactUpgradeMonitoring } from '@travel/tracker'; //TODO: remove this when we finish React 19 migration
import { getDeviceType } from '@travel/traveler-core/utils';
import UIComponentContext from '@travel/ui/contexts';

import { createApiClient } from 'promotions/core/httpClient';
import commonErrorHandler from 'promotions/core/httpClient/commonErrorHandler';
import requestInterceptor from 'promotions/core/httpClient/requestInterceptor';
import responseInterceptor from 'promotions/core/httpClient/responseInterceptor';
import universalRouter from 'promotions/core/universalRouter';
import { Link } from 'promotions/core/universalRouter/Link';
import Router from 'promotions/core/universalRouter/Router';

import createAppStore from 'promotions/store';

setReactUpgradeMonitoring(); //TODO: remove this when we finish React 19 migration
const apiClient = createApiClient();

const history = createBrowserHistory({
  basename: window.PRELOADED_STATE.router.baseUrl,
});
const ssrDeviceType = getDeviceType(window.PRELOADED_STATE.userAgent);
const store = createAppStore({ preloadedState: window.PRELOADED_STATE, history, apiClient });

apiClient.setRequestInterceptor(requestInterceptor(store));
apiClient.setResponseInterceptor(responseInterceptor(store));
apiClient.setCommonErrorHandler(commonErrorHandler(store));

// initialize labels
// initTranslation(store.getState().labels.dictionary || {});

loadableReady(async () => {
  const router = universalRouter({ store });
  const children = await router.resolve({
    ...history.location,
    skipResolver: true,
  });

  hydrateRoot(
    document.getElementById('root') as any,
    <HelmetProvider>
      <UIComponentContext.Provider
        value={{
          ssrDeviceType: ssrDeviceType,
          LinkComponent: ({ href, children, ...rest }) => (
            <Link to={href || ''} {...rest}>
              {children}
            </Link>
          ),
        }}
      >
        <ApiClientProvider apiClient={apiClient}>
          <ReduxProvider store={store}>
            <Router history={history} router={router}>
              {children}
            </Router>
          </ReduxProvider>
        </ApiClientProvider>
      </UIComponentContext.Provider>
    </HelmetProvider>,
  );
});
